import { motion } from "framer-motion";
import { SectionHeading, SectionLabel } from "./Section";

const quotes = [
  "Learn Faster Than The Market Changes.",
  "Discipline Compounds.",
  "Curiosity Creates Opportunity.",
  "Technology Rewards Builders.",
];

export function Principles() {
  return (
    <section className="relative py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 max-w-2xl">
          <SectionLabel>Principles</SectionLabel>
          <SectionHeading>Quiet rules I live by.</SectionHeading>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {quotes.map((q, i) => (
            <motion.blockquote
              key={q}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-gradient-to-br from-white/[0.04] via-transparent to-transparent p-8"
            >
              <div className="absolute left-6 top-4 text-5xl font-serif text-electric/30">"</div>
              <p className="relative pt-6 text-xl font-medium leading-snug tracking-tight sm:text-2xl">
                {q}
              </p>
              <div className="mt-6 flex items-center gap-3 text-xs text-muted-foreground">
                <span className="h-px w-8 bg-electric/50" />
                Principle · 0{i + 1}
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
